export const ALL_GROUP_NAME = "All";
